<div class="row mt-2">
  <div class="col-md-4">
    <div class="card">
      <div class="card-header">
        <div class="card-title mb-0"><strong>Partnership Form</strong></div>
      </div>
      <div class="card-body">
        <form #f="ngForm" (ngSubmit)="f.valid && submit()" novalidate>

          <div class="mb-3">
            <label class="form-label">Name <em>*</em></label>
            <input type="text" class="form-control" name="name" #name="ngModel" [(ngModel)]="data.name" required>
            <div *ngIf="f.submitted && name.invalid" class="invalid-feedback">
              <div *ngIf="name.errors.required">Name is required</div>
            </div>
          </div>

          <div class="mb-3">
            <label class="form-label">Image</label>
            <app-image-uploader [type]="'single'" (uploadEvent)="upload($event, 'image', true)"
              (deleteEvent)="delete($event, 'image')" [loadImage]="data.image"></app-image-uploader>
          </div>

          <div class="mb-3">
            <label class="form-label">Link <em>*</em></label>
            <input type="url" class="form-control" name="link" #link="ngModel" [(ngModel)]="data.link" required>
            <div *ngIf="f.submitted && link.invalid" class="invalid-feedback">
              <div *ngIf="link.errors.required">Link is required</div>
            </div>
          </div>

          <div class="mb-3">
            <label class="form-label">Sort</label>
            <input type="number" class="form-control" name="sort" [(ngModel)]="data.sort">
          </div>

          <div class="mb-3">
            <label class="form-label">Status <em>*</em></label>
            <select class="form-control" name="status" #status="ngModel" [(ngModel)]="data.status" required>
              <option [value]="1">Active</option>
              <option [value]="0">Disabled</option>
            </select>
            <div *ngIf="f.submitted && status.invalid" class="invalid-feedback">
              <div *ngIf="status.errors.required">Status is required</div>
            </div>
          </div>

          <button type="submit" class="btn btn-primary w-100">Save</button>
        </form>
      </div>
    </div>
  </div>
</div>
